import { makeStyles } from "@material-ui/core";

const usePathStyles = makeStyles((theme) => ({
  container: {
    display: "grid",
    marginTop: 20,
    justifyContent: "center",
  },
  title: { marginBottom: 15, marginTop: 15 },
  button: {
    width: 420,
    height: 60,
    marginBottom: 14,
    fontSize: 24,
  },
}));

export default usePathStyles;
